package io.eqoty.shared.ui.utils

import kotlinx.browser.window

val ScreenSizeUtils.smallScaffoldActive: Boolean
    get() = isSmallScaffoldMode(window.innerWidth, window.innerHeight)